import { Component, OnInit, ElementRef } from '@angular/core';
import { AppConstants, LabelConstants } from 'src/app/utilities/app-constants';
import { environment } from 'src/environments/environment';
import { FolioHelperService } from 'src/app/utilities/folio-helper.service';
import { IValidationResponse } from 'src/app/models/validation-response';

/**
 * In this component, we will be redirecting the user to the SP page
 * by attaching the users' access token & environment ID.
 */
@Component({
  selector: 'app-sp-assessments',
  templateUrl: './sp-assessments.component.html',
  styleUrls: ['./sp-assessments.component.css']
})
export class SpAssessmentsComponent implements OnInit {
  readonly MY_CONSTANT = LabelConstants;

  rootUrl = environment.urlRedirectToSpAssessments;
  token = '';
  appName = AppConstants.APP_NAME;
  orgId = 75;
  ampersand = '&';
  spAccessUrl = '';

  constructor(private folioHelperService: FolioHelperService) { }

  ngOnInit() {

    const loggedInUserInfo: IValidationResponse = this.folioHelperService.fetchDataFromLocalStorage
      (AppConstants.PARAM_LOCAL_STORAGE_AUTH_LOGIN_INFO);

    const custEnvId: number = loggedInUserInfo ? loggedInUserInfo.customerId : 0;
    const userId: number = loggedInUserInfo ? loggedInUserInfo.userId : 0;

    this.spAccessUrl = this.rootUrl
      + AppConstants.PARAM_LABEL_SP_ASSESSMENTS_TOKEN
      + '='
      + localStorage.getItem(AppConstants.PARAM_LOCAL_STORAGE_AUTH_TOKEN)
      + this.ampersand
      + AppConstants.PARAM_LABEL_SP_ASSESSMENTS_APP_NAME
      + '='
      + this.appName
      + this.ampersand
      + AppConstants.PARAM_LABEL_SP_ASSESSMENTS_ORG_ID
      + '='
      + custEnvId
      + '&userId=' + userId
      + '&showSPHeaders=false'
      + '&appId=9';

  }
}
